import FaqAccordion from './sections/FaqAccordion';
import FaqIllustrationCard from './sections/FaqIllustrationCard';

const FaqSection = () => {
  return (
    <section className="py-16 sm:py-20 md:py-24 px-4 sm:px-8 md:px-12 bg-white relative overflow-hidden">
      <div className="max-w-7xl 2xl:max-w-[1600px] mx-auto w-full flex flex-col lg:flex-row gap-10 lg:gap-16 xl:gap-20 items-center">
        {/* LEFT SIDE: FAQs Accordion */}
        <FaqAccordion />

        {/* RIGHT SIDE: Illustration */}
        <FaqIllustrationCard />
      </div>
    </section>
  );
};

export default FaqSection;
